import React, { memo } from "react";
import useEventPreview from "./index.hooks";
import EventBannerPlaceholder from "assets/images/event-image-placeholder.jpeg";
import { Divider, Fab, Grid, Tooltip, Typography } from "@material-ui/core";
import { AppPaper } from "components/index";
import { Event } from "models";
import EditIcon from "@material-ui/icons/Edit";

type EventPreviewProps = {
  event?: Event;
  isDefault?: boolean;
  buttonOnClick?: any;
  isInEditDialog?: boolean;
  minWidth?: number;
  maxWidth?: number;
  minHeight?: number;
  maxHeight?: number;
};

const EventPreview = ({
  event,
  isDefault = false,
  isInEditDialog,
  buttonOnClick,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
}: EventPreviewProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    timeExpire,
    setEventEditImageChanger,
    t,
  } = useEventPreview(event);

  return (
    <AppPaper
      classes={classes.paper}
      style={{
        minHeight: minHeight,
        maxHeight: maxHeight,
        minWidth: minWidth,
        maxWidth: maxWidth,
      }}
    >
      {isInEditDialog && (
        <Fab
          className={styles.editButton}
          color={"primary"}
          onClick={setEventEditImageChanger}
        >
          <EditIcon />
        </Fab>
      )}
      {isDefault ? (
        <img
          className={styles.bannerPreview}
          src={
            event.imageUri === undefined
              ? EventBannerPlaceholder
              : event.imageUri
          }
          alt="banner"
        />
      ) : (
        <img
          className={styles.bannerPreview}
          src={event.imageUri === "" ? EventBannerPlaceholder : event.imageUri}
          alt="banner"
        />
      )}
      <div className={styles.eventPaperBottomContent}>
        <Typography className={styles.titlePreview}>
          {event.title && event.title.trim() !== "" ? event.title : t("Titolo")}
        </Typography>
        <Typography noWrap className={styles.contentPreview}>
          {event.title && event.content?.trim() !== ""
            ? event.content
            : t("Breve descrizione della promozione")}
        </Typography>
        <Divider className={styles.textPreviewDivider} />
        {isDefault ? (
          <Grid container direction="row">
            <Grid item xs={9}>
              <Typography className={styles.timingInfo}>
                {event.expiringMinutes
                  ? (timeExpire.days >= 1
                      ? timeExpire.days.toString() + t(" Giorni ")
                      : "") +
                    (timeExpire.hours >= 1
                      ? timeExpire.hours.toString() + t(" Ore ")
                      : "") +
                    (timeExpire.minutes > 0
                      ? timeExpire.minutes + t(" Minuti") + " "
                      : "")
                  : t("Scadenza")}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Tooltip title={"Edit"} enterTouchDelay={1}>
                <Fab
                  className={styles.buttonAdd}
                  color="primary"
                  onClick={buttonOnClick}
                >
                  <EditIcon />
                </Fab>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <Typography className={styles.timingInfo}>
            {t("Valida fino al giorno ")} {event.formattedTo}
          </Typography>
        )}
      </div>
    </AppPaper>
  );
};

export default memo(EventPreview);
